import * as React from 'react';
import styled from '@independent-software/typeui/styles/Theme'
import { NavLink } from 'react-router-dom';

import { Ripple } from '@independent-software/typeui/controls/Ripple'

import { IAuth } from '../../AuthContext';
import { ISubmenu } from '../../config/Menu';
import { Header } from './SidebarHeader';

interface IGroupProps {
  /** @ignore */
  className?: string;
  /* Group title */
  title: string;
  /* Is this group currently open? */
  open: boolean;
  /* Submenu to show in group */
  menu: ISubmenu;
  /** Fired when item in group is clicked */
  onClick: (key: string) => void;
  auth: IAuth;
}

const GroupBase = (props: IGroupProps) => {

  const handleHeaderClick = () => {
    props.onClick(props.title);
  }

  // If there any route available to which the current user
  // has the right to go?
  const anyRouteAvailable = Object.keys(props.menu).some((key) => props.menu[key].isAllowed(props.auth));

  // Only render group if there is at least one available route.
  if(!anyRouteAvailable) return null;

  return (
    <div className={props.className}>
      <Header open={props.open} onClick={handleHeaderClick}>{props.title}</Header>
      <List>
        {Object.keys(props.menu).map(function(key, index) {
          const route = props.menu[key];
          if(route.isAllowed(props.auth)) {
            return (
              <Item key={index} type="div">
                <NavLink key={index} to={route.path}>{key}</NavLink>
              </Item>)
          }
        })}
      </List>
    </div>
  );
}

const List = styled.div`
  height: auto;
  overflow-y: hidden;
  transition: max-height 0.3s ease;
`;

const Item = styled(Ripple)`
  background: rgb(16, 108, 200);

  /* User cannot select item text.
   * This prevents accidental selection when clicking the header.
   */
  user-select: none;

  a {
    display: block;
    font-weight: 500;
    padding: 5px 10px;
    color: #fff;
    outline: none;
    text-decoration: none;
    &:link { color: #fff; }
    &:visited { color: #fff; }
    &:hover { color: #fff; }
    &:active { color: #fff; }
    &.active {
      background: rgb(38, 126, 213);
    }
  }
`

const Group = styled(GroupBase)`
  position: relative;
  ${List} {
    max-height: ${p => p.open ? '1000px' : '0px'};
  }
  margin-bottom: 8px;
`

export { Group };
